import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, HostListener, Input, OnInit, QueryList, Renderer2, TemplateRef, ViewChild, ViewChildren, ViewContainerRef } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { MeetingResponse, MinutesCollabDetails } from 'src/app/models/basicMeetingModel';
import { AttachmentService } from 'src/app/service/attachment.service';
import { FreeFormAgendaService } from 'src/app/service/free-form-agenda.service';
import { FreeFormMinutesService } from 'src/app/service/free-form-minutes.service';
import { Globals } from 'src/app/service/global';
import { MeetingService } from 'src/app/service/meeting.service';
import { PermissionService } from 'src/app/service/permission.service';
import { SideNavServiceService } from 'src/app/service/side-nav-service.service';
import { UtilityService } from 'src/app/service/utility.service';
import { AddLinkDialogComponent } from '../add-link-dialog/add-link-dialog.component';
import { AttachmentDialogComponent } from '../attachment-dialog/attachment-dialog.component';
import { meetingTourValues, scheduleMeetingTourValues, pastMeetingTourValues, environment_const, environment_msg, environment } from 'src/environments/environment';
import { UtcDatePipe } from 'src/app/pipe/UtcDate.pipe';
import { HistoryComponent } from '../history/history.component';
import { HistoryDialogService } from 'src/app/service/history-dialog.service';
import { LinkNotetotaskDialogComponent } from '../link-notetotask-dialog/link-notetotask-dialog.component';
import { T } from '@angular/cdk/keycodes';
import { ProteanFormsComponent } from '../protean-forms/protean-forms.component';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NotifierService } from 'angular-notifier';
import { AgoraConfigService } from 'src/AgoraConfigService';
import Quill from 'quill';
import { buildQuillModules, setupQuillUploadAdapter } from 'src/app/config/quill-common';
import { quillSharedToolbar } from 'src/app/config/quill-shared-toolbar';
@Component({
  selector: 'app-instant-meeting-note',
  templateUrl: './instant-meeting-note.component.html',
  styleUrls: ['./instant-meeting-note.component.css'],
  providers: [UtcDatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InstantMeetingNoteComponent implements OnInit, AfterViewInit {
  @ViewChildren('noteFocus') noteElements!: QueryList<ElementRef>;
  //UI Team variable declaration
  @Input() hideParts: any
  disaleAttachmentFileIcon: any;
  meetingTourValues = meetingTourValues
  scheduleMeetingTourValues = scheduleMeetingTourValues
  pastMeetingTourValues = pastMeetingTourValues
  //padllock variable
  matDialogRef!: MatDialogRef<AttachmentDialogComponent>;
  padlock: any;
  isPrivate: any;
  decryptKey: string = '';
  assignedToMapassignedToList: string[] = [];
  assignedToMap: any = {}; // reset first
  collabVariable = 'active'
  agendaAttachResp: any;
  attachCount: boolean = true;
  attachmentCount: any;
  responsevalue: any;
  attachmentTotalCnt: any = true;
  attachmentIcon = 'Y';
  padlockDisable: any;
  proteanHtml?: SafeHtml;
  proteanFormId: any;
  userResponse: any = [];
  @Input() pinDialogTriggered = false;
  editCollabData = <MinutesCollabDetails>{};
  isExtraSmall: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.XSmall
  );
  isMedium: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.Medium
  )
  isSmall: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.Small
  )
  @Input() videoSectionStatusChecker: any
  disableNotesIcon: any;

  //property for adding new class for login user is a task user.
  selectedTabName: any;
  meetingInfoData: any;
  toLinkingTask: any;
  taskInfo: any;
  agendasinfoe: any;
  noteInfo: any;
  rightsList: any;
  hideSaveButton = true;
  currentUser: any
  selectedUser: any;
  private blurSavingGuard: boolean = false;

  //@ViewChild('noteFocus', {static: false}) noteFocus!: ElementRef;
  constructor(private utility: UtilityService, private permissionService: PermissionService, public sideNavService: SideNavServiceService, private readonly breakpointObserver: BreakpointObserver, public meetingService: MeetingService, private globals: Globals, private dialog: MatDialog, public commonMinService: FreeFormMinutesService, public freeFormAgenda: FreeFormAgendaService, public attachService: AttachmentService, private historyDialogService: HistoryDialogService, private notifier: NotifierService, private sanitizer: DomSanitizer, private agoraConfig: AgoraConfigService) {
  }

  private setupCk5UploadAdapter(editor: any) {
    // CKEditor removed: no-op
    try { /* intentionally empty */ } catch {}
  }
  @Input() minAttrList: any;

  @Input()
  deviceXs!: boolean;

  @Input()
  deviceSm!: boolean;

  @Input()
  deviceMd!: boolean;

  @Input()
  deviceLg!: boolean;

  @Input()
  deviceXl!: boolean;

  showToolTip = false
  @Input() collbElementId: any;
  @Input() contentEditableBoolmin: any

  @Input() meetingResponse: any

  // Shared toolbar/editor state
  private activeEditor: any;
  private toolbarInteracting = false;
  // Quill shared toolbar modules
  public quillModules: any = {};
  // Track this component's Quill instance and active state
  private quillInst?: Quill;
  private isActiveEditor: boolean = false;
  private hasUserInteracted: boolean = false;
  editorConfig = {
    enableTable : true,
    letter : false,
    modules: {
    toolbar: {
    container: [
    ['bold', 'italic', 'underline', 'strike'],    
    [{ list: 'ordered' }, { list: 'bullet' }],    
    [{ indent: '+1' }, { indent: '-1' }],        
    [{ color: [] }, { background: [] }],        
    ['image','link'],
    ],
    handlers: {
    insertheaderorfooter: () => {}, // just placeholder, real action via emitter
    subreport: () => {},
    preview: () => {},
    print: () => {},
    formula: () => {},
    },
    },
    },
    sharedToolbar : {enabled:true , selectorId:'quill-shared-toolbar'},
    placeholder: " ",
    theme: 'snow',
    };

  ngOnInit(): void {
    // Ensure shared toolbar container can be shown
    this.commonMinService.setActivateCkEditor(true);
    this.currentUser = localStorage.getItem('userId');
    var padLockValue = this.minAttrList.isPrivate;
    if (padLockValue == 'Y') {
      this.padlock = true;
    } else {
      this.padlock = false;
    }
    // Prepare Quill modules (shared toolbar host)
    try {
      this.quillModules = buildQuillModules(this.meetingResponse);
    } catch { this.quillModules = { toolbar: '#quill-shared-toolbar' }; }
    this.rightsList = this.meetingResponse.attendeeList.filter((user: any) => this.minAttrList.formDetails.editRights.includes(user.fkSecUserAttendee + ""));

  }
  ngAfterViewInit() {
    // CKEditor 5 Angular wrapper manages instances; no CK4 activation
    var roleFlag = this.permissionService.checkRoleRightsWithNoAlert(this.utility.featureList.NOTES, this.utility.permissionType.MODIFY);


    if (!roleFlag) {
      this.disableNotesIcon = true;
      // $("#insertAttendeeSec").attr('contenteditable', false);
      this.selectedTabName = roleFlag;
    } else {
      this.disableNotesIcon = false;

    }
    if (this.contentEditableBoolmin == false) {
      for (var i = 0; i < document.getElementsByClassName('agChildNote').length; i++) {
        document.getElementsByClassName('agChildNote')[i].setAttribute('contenteditable', 'false')
      }
    }
    //code added to allow to make private only for created user
    if (this.minAttrList.createdBy == localStorage.getItem("userId")) {
      this.padlockDisable = false;
    } else {
      this.padlockDisable = true;
    }
    //close

    if (this.minAttrList.formDetails != null && this.minAttrList.formDetails != undefined) {
      if (this.minAttrList.formDetails.editRights.includes(this.currentUser) && this.minAttrList.formDetails.formResponse != null && this.minAttrList.formDetails.formResponse != undefined) {
        const userIdToFind = localStorage.getItem('userId');
        this.userResponse = this.minAttrList.formDetails.formResponse.filter((item: any) => item.userId == userIdToFind);
        if (this.userResponse.length > 0) {
          var request = {
            formId: this.minAttrList.formDetails.formId,
            responseId: this.userResponse[0].responseId
          }
          this.selectedUser = this.userResponse[0].userId;
          this.getFormDetails(request);
        } else {
          var req = {
            formId: this.minAttrList.formDetails.formId,
          }
          this.selectedUser = this.currentUser;
          this.getFormDetails(req);
        }
      }
      else {
        if (this.minAttrList.formDetails.editRights.includes(this.currentUser)) {
          var req = {
            formId: this.minAttrList.formDetails.formId
          }
          this.selectedUser = this.currentUser + "";
          this.getFormDetails(req);
        }
        else {
          if (this.minAttrList.formDetails.formResponse != null && this.minAttrList.formDetails.formResponse != undefined) {
            var request = {
              formId: this.minAttrList.formDetails.formId,
              responseId: this.minAttrList.formDetails.formResponse[0].responseId
            }
            this.selectedUser = this.minAttrList.formDetails.formResponse[0].userId + "";
            this.getFormDetails(request);
          }
          else {
            var req = {
              formId: this.minAttrList.formDetails.formId
            }
            this.selectedUser = this.minAttrList.formDetails.editRights[0] + "";
            this.getFormDetails(req);
          }

        }
      }
    }

  }

  handleMouseUp(noteElement: HTMLDivElement): void {
    const selection = window.getSelection();
    if (selection && selection.toString()) {
      noteElement.setAttribute('highlightIndex', '0');
    }
  }
  handleFocus(event: FocusEvent, noteElement: HTMLDivElement): void {
    this.sideNavService.closeAllAccordtion();
    this.sideNavService.smootherScroll(event.target);
    noteElement.setAttribute('highlightIndex', '0');
  }

  handleKeyDown(event: KeyboardEvent, noteElement: HTMLDivElement): void {
    // Skip Alt+N/D/T/1/2/3/G shortcuts - they're handled separately in the keydown listener
    const isAltShortcut = event.altKey && (
      event.keyCode === 78 || // N
      event.keyCode === 68 || // D
      event.keyCode === 84 || // T
      event.keyCode === 49 || event.keyCode === 97 || // 1
      event.keyCode === 50 || event.keyCode === 98 || // 2
      event.keyCode === 51 || event.keyCode === 99 || // 3
      event.keyCode === 71    // G
    );
    if (!isAltShortcut) {
      this.freeFormAgenda.trackChangesWhileEditing(
        noteElement.getAttribute('noteId')!,
        noteElement.getAttribute('agId')!,
        event,
        noteElement.getAttribute('entityType')!,
        'agMinId' + noteElement.getAttribute('noteId')
      );
    }
    if (event.ctrlKey && event.shiftKey && event.key.toLowerCase() === 'h') {
      event.preventDefault();
      this.highlightNextText(noteElement);
    }
  }

  highlightNextText(noteElement: HTMLDivElement): void {
    // const regex = /\[XXXXXX\]/gi;
    const regex = environment_const.patternKey;
    const content = noteElement.textContent || '';
    const matches = Array.from(content.matchAll(regex));
    const count = matches.length;
    if (count === 0) return;

    let currentIndex = parseInt(noteElement.getAttribute('highlightIndex') || '0', 10);
    noteElement.setAttribute('highlightIndex', ((currentIndex + 1) % count).toString());

    this.applyHighlight(noteElement, matches, currentIndex);
  }

  applyHighlight(noteElement: HTMLDivElement, matches: RegExpMatchArray[], highlightIndex: number): void {
    if (!noteElement.firstChild) return;

    const selection = window.getSelection();
    const range = document.createRange();

    const match = matches[highlightIndex];
    if (!match) return;
    const start = match.index!;
    const end = start + match[0].length;


    let offset = 0;
    let found = false;
    const nodes = Array.from(noteElement.childNodes);
    for (const node of nodes) {
      const nodeLength = node.textContent?.length || 0;

      if (offset + nodeLength >= start && !found) {
        const relativeStart = start - offset;
        const relativeEnd = end - offset;

        range.setStart(node, relativeStart);
        range.setEnd(node, Math.min(relativeEnd, nodeLength));

        found = true;
        break;
      }

      offset += nodeLength;
    }

    if (found) {
      selection?.removeAllRanges();
      selection?.addRange(range);
    }
  }

  // Legacy CKEditor activation removed
  getMinComStatusCode() {

    if (this.meetingResponse.commonMomStatusCode == 'A') {
      this.disaleAttachmentFileIcon = true;
    } else {
      this.disaleAttachmentFileIcon = false;
    }
  }

  ngOnDestroy() {

    //  for (var instance in CKEDITOR.instances) {
    //    CKEDITOR.instances[instance].destroy();
    //  }
  }
  //attachment dialog function
  openConfidentialDialog(e: any, m: any) {

    let attchDialog = this.dialog.open(AttachmentDialogComponent, {
      data: {
        e, m, "data": this.contentEditableBoolmin,
        "disaleAttachmentFileIcon": this.disaleAttachmentFileIcon
      },
      panelClass: ['animate__animated', 'animate__slideInLeft'],
      disableClose: true,
      position: {
        left: "0%"
      },
      maxWidth: "100%",
      maxHeight: "100vh",
      width: "50%",
      height: "100vh"
    })
    const mediumDialogSubscription = this.isMedium.subscribe(size => {
      if (size.matches) {
        attchDialog.updateSize('70vw', '100vh');
      }
    })
    const smallSubscription = this.isSmall.subscribe(size => {
      if (size.matches) {
        attchDialog.updateSize('100vw', '100vh');
      }
    })
    const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
      if (size.matches) {
        attchDialog.updateSize('100vw', '100vh');
      }
    });
    attchDialog.afterClosed().subscribe((response: any) => {
      mediumDialogSubscription.unsubscribe()
      smallSubscription.unsubscribe()
      smallDialogSubscription.unsubscribe()
      this.meetingService.fetchNotes(e._id).subscribe((data: any) => {

        if (data != undefined) {
          var minAttrList = this.minAttrList;
          if (minAttrList != null) {
            this.minAttrList.attachmentTotalCnt = data.body.attachmentTotalCnt
            this.freeFormAgenda.pushAttachmentCount(this.minAttrList, data.body.attachmentTotalCnt, 'MN');
          }
        }
      });

    })
    //
  }

  bringPointerDown(id: any) {
    let elementId = "agMinId" + id;

    $('#' + elementId).each(function () {
      if ($(this).find('img').length) {
        <HTMLElement><unknown>document.getElementById(elementId)?.setAttribute("style", "display : flex; align-items : end")
      }
    });
  }

  trackChanges(id: any) {
    this.showToolTip = true;
    //
    let elementCreation = document.getElementById('agMinId' + id);
    $('#agMinId' + id).css("border", "5px solid rgba(0,0,0,.12)")
  }

  removeTrackChanges(id: any) {
    $('#agMinId' + id).css("border", "0px")
    this.showToolTip = false
  }

  // <span class="ck-user__marker ck-user__marker--2" data-name="Sebastian Harrison" data-session-id="Ex62OzZBGwPwMZ1DAPlr">&ZeroWidthSpace;<span class="ck-user__marker-line"><span class="ck-user__marker-dot"></span></span></span>


  addNewLink(entityId: any, meetingId: any) {
    let linkDialog = this.dialog.open(AddLinkDialogComponent, {
      data: { entityId, meetingId, "entityType": "MN", "attachmentMode": "LI", "data": this.contentEditableBoolmin, "disaleAttachmentFileIcon": this.disaleAttachmentFileIcon },
      panelClass: ['animate__animated', 'animate__slideInLeft'],
      disableClose: true,
      position: {
        left: "0%"
      },
      maxWidth: "100%",
      maxHeight: "100vh",
      width: "50%",
      height: "100vh"
    })
    const mediumDialogSubscription = this.isMedium.subscribe(size => {
      if (size.matches) {
        linkDialog.updateSize('70vw', '100vh');
      }
    })
    const smallSubscription = this.isSmall.subscribe(size => {
      if (size.matches) {
        linkDialog.updateSize('100vw', '100vh');
      }
    })
    const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
      if (size.matches) {
        linkDialog.updateSize('100vw', '100vh');
      }
    });
    linkDialog.afterClosed().subscribe((response: any) => {
      mediumDialogSubscription.unsubscribe()
      smallSubscription.unsubscribe()
      smallDialogSubscription.unsubscribe()
      this.meetingService.fetchNotes(entityId).subscribe((data: any) => {

        if (data != undefined) {
          var minAttrList = this.minAttrList;
          if (minAttrList != null) {
            this.minAttrList.attachmentTotalCnt = data.body.attachmentTotalCnt
            this.freeFormAgenda.pushAttachmentCount(this.minAttrList, data.body.attachmentTotalCnt, 'MN');
          }
        }
      });

    })
  }

  statusTracker(id: any, vari: any) {
    if (vari == 'active') {
      let element = (<HTMLElement>document.getElementById("agMinId" + id))
      element.contentEditable = 'false'
    }
    else if (vari == 'inActive') {
      let element = (<HTMLElement>document.getElementById("agMinId" + id))
      element.contentEditable = 'true'
    }
  }



  //padlock toggle function

  togglePadLock(e: any) {
    console.log("INSIDE PADLOCK TOGGLEs",e.target.textContent);
    
    // if ((e.target.textContent).trim() == "lock_open") {
    //   this.isPrivate = "Y";
    // }
    // else {
    //   this.isPrivate = "N";
    // }
    // console.log("this.isPrivate=",this.isPrivate);
    
    // this.padlock = !this.padlock;
  //   this.isPrivate = !this.isPrivate;
  // this.padlock = this.isPrivate;
   this.padlock = !this.padlock;
  this.isPrivate = this.padlock ? 'Y' : 'N';

  console.log('Padlock toggled →', this.padlock, 'isPrivate:', this.isPrivate);

  // Update the bound data model
  if (this.minAttrList) {
    this.minAttrList.isPrivate = this.isPrivate;
  }
    var data = {}
    var noteJson = {
      "isPrivate": this.isPrivate,
      "agendaId": this.minAttrList.agendaId,
      "meetingId": this.minAttrList.meetingId,
      "entityType": this.minAttrList.entityType,
      "minutesId": this.minAttrList.noteId,
      "noteTypeCode": this.minAttrList.noteTypeCode,
      "noteId": this.minAttrList.noteId,
    }

    var saveUrl = this.freeFormAgenda.getSaveUrl("Y", this.minAttrList.entityType, noteJson);
    this.freeFormAgenda.saveMinutesAttributes(data, noteJson, saveUrl, "Y").then((result: any) => {
      Object.assign(this.minAttrList, result);
      if (this.isPrivate == 'Y') {
        this.editCollabData.elementId = this.minAttrList.noteId;
        this.editCollabData.agElementId = this.minAttrList.agendaId;
        this.editCollabData.meetingId = this.minAttrList.meetingId;
        this.editCollabData.collabType = 'MINPRIVATE'
      } else {
        this.meetingResponse.agendaList.forEach((agElem: any, agIndex: any) => {

          if (agElem.agendaId == this.minAttrList.agendaId) {

            this.editCollabData.agElemPosition = agIndex;

            if (agElem.minutesList != null && agElem.minutesList != undefined) {
              agElem.minutesList?.forEach((minElem: any, minIndex: any) => {

                if ((minElem.noteId != null && minElem.noteId == this.minAttrList.noteId)) {

                  this.editCollabData.minElemPosition = minIndex;
                }
              });
            }
          }
        });
        this.editCollabData.elementVal = this.minAttrList;
        this.editCollabData.collabType = 'MIN';
        this.editCollabData.elementId = this.minAttrList.noteId;
        this.editCollabData.meetingId = this.minAttrList.meetingId;
      }

      this.freeFormAgenda.callPushMessageToServer(this.editCollabData, '', '');

    });


  }

  toggleResPadLock(e: any) {

    // if ((e.target.textContent).trim() == "lock_open private" || (e.target.textContent).trim() == "lock_open") {
    //   this.isPrivate = "Y";
    // }
    // else {
    //   this.isPrivate = "N";
    // }
    // this.padlock = !this.padlock;
    this.padlock = !this.padlock;
  this.isPrivate = this.padlock ? 'Y' : 'N';
    var data = {}
    var noteJson = {
      "isPrivate": this.isPrivate,
      "agendaId": this.minAttrList.agendaId,
      "meetingId": this.minAttrList.meetingId,
      "entityType": this.minAttrList.entityType,
      "minutesId": this.minAttrList.noteId,
      "noteTypeCode": this.minAttrList.noteTypeCode,
      "noteId": this.minAttrList.noteId,
    }

    var saveUrl = this.freeFormAgenda.getSaveUrl("Y", this.minAttrList.entityType, noteJson);
    this.freeFormAgenda.saveMinutesAttributes(data, noteJson, saveUrl, "Y").then((result: any) => {
      if (this.isPrivate == 'Y') {
        this.editCollabData.elementId = this.minAttrList.noteId;
        this.editCollabData.agElementId = this.minAttrList.agendaId;
        this.editCollabData.meetingId = this.minAttrList.meetingId;
        this.editCollabData.collabType = 'MINPRIVATE'
      } else {
        this.meetingResponse.agendaList.forEach((agElem: any, agIndex: any) => {

          if (agElem.agendaId == this.minAttrList.agendaId) {

            this.editCollabData.agElemPosition = agIndex;

            if (agElem.minutesList != null && agElem.minutesList != undefined) {
              agElem.minutesList.forEach((minElem: any, minIndex: any) => {

                if ((minElem.noteId != null && minElem.noteId == this.minAttrList.noteId)) {

                  this.editCollabData.minElemPosition = minIndex;
                }
              });
            }
          }
        });
        this.editCollabData.elementVal = this.minAttrList;
        this.editCollabData.collabType = 'MIN';
        this.editCollabData.elementId = this.minAttrList.noteId;
        this.editCollabData.meetingId = this.minAttrList.meetingId;
      }

      this.freeFormAgenda.callPushMessageToServer(this.editCollabData, '', '');

    });

  }

  getAttachCount(e: any) {

    this.meetingService.fetchNotes(e.noteId).subscribe((data: any) => {
      this.agendaAttachResp = data.body;

      this.attachCount = false;
    });
  }

  ngOnChanges(event: any) {

    // let noteId = event.collbElementId.currentValue
    // let htmlNoteId = 'agMinId'+noteId;
    // let jsAccessNoteId = (<HTMLElement> document.getElementById(htmlNoteId))

    // // let inputFieldCaretIndex = jsAccessNoteId.onselectstart;
    // document.addEventListener('keyup',() => {
    //   let selectionContent = window.getSelection()

    // })

  }

  createEmptyAgenda(event: any) {

    var roleFlag = this.permissionService.checkRoleRightsWithNoAlert(this.utility.featureList.AGENDA, this.utility.permissionType.MODIFY);

    if (!roleFlag) {
      return
    }
    var newAg = 'AG'
    this.freeFormAgenda.trackAgendaEventOnClick(event, newAg);

  }

  createEmptyNote(event: any) {

    var roleFlag = this.permissionService.checkRoleRightsWithNoAlert(this.utility.featureList.NOTES, this.utility.permissionType.MODIFY);

    if (!roleFlag) {
      return
    }
    var entityType = "/nn";
    this.freeFormAgenda.trackAgendaEventOnClick(event, entityType);

  }

  createEmptyTask(event: any) {

    var roleFlag = this.permissionService.checkRoleRightsWithNoAlert(this.utility.featureList.TASK, this.utility.permissionType.MODIFY);

    if (!roleFlag) {
      return
    }
    var entityType = "/tt";
    this.freeFormAgenda.trackAgendaEventOnClick(event, entityType);

  }

  createEmptyDecision(event: any) {

    var roleFlag = this.permissionService.checkRoleRightsWithNoAlert(this.utility.featureList.NOTES, this.utility.permissionType.MODIFY);

    if (!roleFlag) {
      return
    }
    var entityType = "/dd";
    this.freeFormAgenda.trackAgendaEventOnClick(event, entityType);

  }

  history(entityId: any, modifiedName: any) {
    var entityType = 'MN';
    this.historyDialogService.openHistoryDialog(entityId, entityType, modifiedName, this.isMedium, this.isSmall, this.isExtraSmall);
  }
  blur(target: any, event: any) {
    var selectTextAsNote = (event.altKey && (event.keyCode == 78 || event.keyCode == 68 || event.keyCode == 84));//(ALT+N)
    if (selectTextAsNote) {
      this.commonMinService.triggerSaveMinutes(target, event);
    }
  }

  // ===== Quill integration (shared toolbar) =====
  onQuillEditorReady(quill: Quill) {
    try {
      this.quillInst = quill;
      // Register with shared toolbar manager
      try {
        const selectorId = (this as any).editorConfig?.sharedToolbar?.selectorId || 'quill-shared-toolbar';
        quillSharedToolbar.registerEditor(quill, selectorId);
      } catch {}
  
      const rootEl = quill.root as HTMLElement;
      const noteIdVal = this.minAttrList.noteId;
  
      // Ensure legacy attributes on the editable element (services rely on these)
      const ensureLegacyAttrs = () => {
        try {
          rootEl.id = 'agMinId' + noteIdVal;
          rootEl.classList.add('agChildNote', 'minComCls');
          rootEl.setAttribute('minId', String(noteIdVal));
          rootEl.setAttribute('minid', String(noteIdVal));
          rootEl.setAttribute('noteId', String(noteIdVal));
          rootEl.setAttribute('agId', String(this.minAttrList.agendaId));
          rootEl.setAttribute('agid', String(this.minAttrList.agendaId));
          rootEl.setAttribute('parentAgId', String(this.minAttrList.agendaId));
          rootEl.setAttribute('entityType', this.minAttrList?.entityType || 'MN');
        } catch {}
      };
      ensureLegacyAttrs();
  
      // Keep toolbar in sync on focus
      // rootEl.addEventListener('focus', () => quillSharedToolbar.registerEditor(quill));
  
      // Guard blur-save while clicking toolbar
      const selectorId = (this as any).editorConfig?.sharedToolbar?.selectorId || 'quill-shared-toolbar';
      const shared = document.querySelector('#' + selectorId) as HTMLElement | null;
      if (shared) {
        shared.style.display = 'block';
        shared.addEventListener('mousedown', () => { this.toolbarInteracting = true; }, true);
        shared.addEventListener('mouseup', () => { setTimeout(() => this.toolbarInteracting = false, 0); }, true);
        shared.addEventListener('click', () => { setTimeout(() => this.toolbarInteracting = false, 0); }, true);
      }

      // Outside click handler: save when clicking outside editor AND toolbar (only after user interaction)
      let outsideClickHandler: ((ev: MouseEvent) => void) | null = null;
      outsideClickHandler = (ev: MouseEvent) => {
        // Only handle for this instance when it is currently active AND user has interacted
        if (!this.isActiveEditor || !this.hasUserInteracted) return;
        
        const t = ev.target as Node;
        const insideEditor = rootEl.contains(t);
        const insideToolbar = shared ? shared.contains(t) : false;
        
        // Check if clicking another editor
        const targetEl = ev.target as HTMLElement;
        const clickedAnotherEditor = targetEl?.closest?.('.ql-editor') && !insideEditor;
        
        if (!insideEditor && !insideToolbar) {
          // Deactivate this editor and save
          this.isActiveEditor = false;
          this.onQuillBlur();
        }
      };
      document.addEventListener('mousedown', outsideClickHandler, true);
  
      // Map mouseup to legacy selection/highlight
      rootEl.addEventListener('mouseup', () => {
        const noteDiv = document.createElement('div');
        noteDiv.setAttribute('noteId', this.minAttrList.noteId);
        this.handleMouseUp(noteDiv as unknown as HTMLDivElement);
      });
  
      // Click -> bring pointer + reinforce attrs + mark as interacted
      rootEl.addEventListener('click', () => {
        try { this.sideNavService.bringPointer(this.minAttrList.noteId); } catch {}
        ensureLegacyAttrs();
        this.isActiveEditor = true;
        this.hasUserInteracted = true;
      });

      // Mark this instance active on direct interactions (mousedown/focusin)
      rootEl.addEventListener('mousedown', () => { 
        this.isActiveEditor = true; 
        this.hasUserInteracted = true; 
      }, true);
      
      rootEl.addEventListener('focusin', () => { 
        this.isActiveEditor = true; 
        this.hasUserInteracted = true; 
      }, true);

      // If focus moves to another .ql-editor, blur/save this one
      // try {
      //   const focusSwitchHandler = (ev: Event) => {
      //     if (!this.isActiveEditor) return;
      //     const t = ev.target as HTMLElement | null;
      //     if (!t) return;
      //     const targetEditor = t.closest('.ql-editor') as HTMLElement | null;
      //     if (targetEditor && targetEditor !== rootEl) {
      //       this.isActiveEditor = false;
      //       try {
      //         (quill as any).setSelection(null);
      //         (quill as any).enable(false); // simulate destroy when switching away
      //       } catch {}
      //       this.onQuillBlur();
      //     }
      //   };
      //   document.addEventListener('focusin', focusSwitchHandler, true);
      //   document.addEventListener('mousedown', focusSwitchHandler, true);
      // } catch {}
  
      // Debounced typing notifications (Kafka)
      // quill.on('text-change', (_d: any, _o: any, source: string) => {
      //   if (source !== 'user') return;
      //   if (this.typingDebounce) clearTimeout(this.typingDebounce);
      //   this.typingDebounce = setTimeout(() => {
      //     try {
      //       const meetingId = this.meetingResponse?.meetingId;
      //       const elementId = this.minAttrList?.noteId;
      //       if (!meetingId || !elementId) return;
      //       const msg: any = {
      //         collabType: 'MINEDIT',
      //         elementId,
      //         agElemPosition: this.minAttrList?.agElemPosition,
      //         minElemPosition: this.minAttrList?.minElemPosition,
      //       };
      //       this.webTranService.pushTypingNotification(meetingId, msg, elementId).subscribe({ next: () => {}, error: () => {} });
      //     } catch {}
      //   }, 400);
      // });
  
      // Keyboard helpers
      const invokeTrackChanges = (keyCode: number) => {
        ensureLegacyAttrs();
        const editableEl = rootEl;
        const syntheticEvent: any = {
          target: editableEl,
          currentTarget: editableEl,
          altKey: true,
          keyCode,
          preventDefault: () => {},
          stopPropagation: () => {},
        };
        this.freeFormAgenda.trackChangesWhileEditing(
          this.minAttrList.noteId,
          this.minAttrList.agendaId,
          syntheticEvent,
          this.minAttrList.entityType,
          'agMinId' + this.minAttrList.noteId
        );
      };
  
      const invokeAgendaEvent = (code: string) => {
        ensureLegacyAttrs();
        const editableEl = rootEl;
        const syntheticEvent: any = {
          target: editableEl,
          currentTarget: editableEl,
          preventDefault: () => {},
          cancel: () => {}
        };
        this.freeFormAgenda.trackAgendaEventOnClick(syntheticEvent, code);
      };
  
      // Keydown parity with CKEditor: Alt+N/D/T/1/2/3/G and slash tokens on Enter
      rootEl.addEventListener('keydown', (ev: KeyboardEvent) => {
        if (!this.hasUserInteracted) this.hasUserInteracted = true;
        const keyCode = (ev as any).keyCode || ev.which;
  
        // Alt+N/D/T: create from selected text
        const isAltN = ev.altKey && keyCode === 78;
        const isAltD = ev.altKey && keyCode === 68;
        const isAltT = ev.altKey && keyCode === 84;
        if (isAltN || isAltD || isAltT) {
          invokeTrackChanges(keyCode);
          ev.preventDefault(); ev.stopPropagation();
          return;
        }
  
        // Alt+1/2/3: convert minute to Note/Decision/Task
        const isAlt1 = ev.altKey && (keyCode === 49 || keyCode === 97);
        const isAlt2 = ev.altKey && (keyCode === 50 || keyCode === 98);
        const isAlt3 = ev.altKey && (keyCode === 51 || keyCode === 99);
        if (isAlt1 || isAlt2 || isAlt3) {
          invokeTrackChanges(keyCode);
          ev.preventDefault(); ev.stopPropagation();
          return;
        }
  
        // Alt+G: new Agenda
        const isAltG = ev.altKey && keyCode === 71;
        if (isAltG) {
          invokeAgendaEvent('AG');
          ev.preventDefault(); ev.stopPropagation();
          return;
        }
        // Map normal keydowns to the legacy handler (this triggers existing collab/typing flows)
{
  const noteDiv = document.createElement('div');
  noteDiv.classList.add('agChildNote', 'minComCls');
  noteDiv.setAttribute('noteId', this.minAttrList.noteId);
  noteDiv.setAttribute('agId', this.minAttrList.agendaId);
  noteDiv.setAttribute('agid', this.minAttrList.agendaId);
  noteDiv.setAttribute('entityType', this.minAttrList.entityType);
  noteDiv.setAttribute('id', 'agMinId' + this.minAttrList.noteId);
  noteDiv.setAttribute('minId', this.minAttrList.noteId);
  noteDiv.setAttribute('minid', this.minAttrList.noteId);

  const mappedEvent: any = {
    ctrlKey: !!ev.ctrlKey,
    altKey: !!ev.altKey,
    shiftKey: !!ev.shiftKey,
    key: (ev as any).key || '',
    keyCode: (ev as any).keyCode || ev.which,
    preventDefault: () => ev.preventDefault(),
    stopPropagation: () => ev.stopPropagation(),
  };
  // This is the same call your CKEditor path makes
  this.handleKeyDown(mappedEvent, noteDiv as unknown as HTMLDivElement);
}
  
        // Enter: handle trailing slash tokens: delete token, delegate, then blur-save
        if (keyCode === 13) {
          try {
            const sel = quill.getSelection();
            if (!sel) return;
            const caret = sel.index;
            const MAX = 48;
            const start = Math.max(0, caret - MAX);
            // Window and ignore trailing whitespace
            let seg = quill.getText(start, caret - start);
            const trailing = seg.match(/[\s\u00a0]+$/);
            const strip = trailing ? trailing[0].length : 0;
            const effEnd = caret - strip;
            const effLen = effEnd - start;
            if (effLen <= 0) return;
            seg = quill.getText(start, effLen);

            const slash = seg.lastIndexOf('/');
            if (slash < 0) return;
            let token = '/';
            for (let i = slash + 1; i < seg.length && token.length <= 5; i++) {
              const ch = seg[i];
              if (!/[a-z]/i.test(ch)) break;
              token += ch;
            }
            const valid = /^(\/nn|\/dd|\/tt|\/ag|\/sg|\/agl|\/sgl|\/ddl|\/ttl|\/nnl)$/i;
            if (!valid.test(token)) return;

            // Delete only the token from Quill content
            const delLen = token.length + strip;
            quill.deleteText(effEnd - token.length, delLen, 'user');

            // Delegate to legacy handler which will insert proper structures
            const root = quill.root as HTMLElement;
            try {
              root.id = 'agMinId' + String(this.minAttrList.noteId);
              root.classList.add('agChildNote', 'minComCls');
              root.setAttribute('noteId', String(this.minAttrList.noteId));
              root.setAttribute('minId', String(this.minAttrList.noteId));
              root.setAttribute('minid', String(this.minAttrList.noteId));
              root.setAttribute('agId', String(this.minAttrList.agendaId));
              root.setAttribute('agid', String(this.minAttrList.agendaId));
              root.setAttribute('entityType', String(this.minAttrList.entityType || 'MN'));
              const t = token.toLowerCase();
              if (t === '/ag') {
                try { root.removeAttribute('parentAgId'); } catch {}
              } else if (t === '/sg') {
                try { root.setAttribute('parentAgId', String(this.minAttrList.agendaId)); } catch {}
              }
            } catch {}

            const syntheticEvent: any = {
              target: root,
              currentTarget: root,
              preventDefault: () => {},
              cancel: () => {}
            };
            (this.freeFormAgenda as any).trackAgendaEventOnClick(syntheticEvent, token.toLowerCase());

            // Mark interacted and force immediate and delayed blur-saves for reliability
            try { this.hasUserInteracted = true; } catch {}
            try { setTimeout(() => this.onQuillBlur(), 50); } catch {}
            try { setTimeout(() => this.onQuillBlur(), 300); } catch {}

            ev.preventDefault(); ev.stopPropagation();
            return;
          } catch {}
        }
      });
  
    } catch {}


    try {
      const cfg = this.agoraConfig.getConfig();
      setupQuillUploadAdapter(
        quill,
        cfg.apiBaseUrl,
        cfg.endpoints.attachment,
        this.freeFormAgenda.meetingResponse?.meetingId,
        this.minAttrList.agendaId,
        (_url: string) => {
          // Optional: trigger save like CK after insertion
          setTimeout(() => { this.onQuillBlur(); }, 0);
        }
      );
    } catch {}
  }

  onQuillSelectionChanged(e: any) {
    // DO NOT use selection-change for blur - it fires on load and causes unwanted saves
    // Blur is handled by outside click handler only
  }

  onQuillFocus() {
    try { 
      this.isActiveEditor = true; 
      this.hasUserInteracted = true; 
      this.showToolTip = true; 
    } catch {}
  }

  onQuillBlur() {
    try {
      // Only save if user has actually interacted with this editor
      if (!this.hasUserInteracted) return;
      
      // Guard against toolbar interactions and duplicate saves
      if (this.toolbarInteracting || this.blurSavingGuard) return;
      
      this.blurSavingGuard = true;
      const noteIdVal = this.minAttrList.noteId;
      const host = document.getElementById('agMinId' + noteIdVal) as HTMLElement | null;
      const html = host ? host.innerHTML : (this.minAttrList?.noteDescription || '');
      // Update local model so subsequent re-inits show latest content immediately
      try {
        this.minAttrList.noteDescription = html || '';
        // Also update meetingResponse tree (agenda -> minutes -> this note)
        const agList = (this.meetingResponse && Array.isArray(this.meetingResponse.agendaList)) ? this.meetingResponse.agendaList : [];
        for (const ag of agList) {
          if (ag && Array.isArray(ag.minutesList)) {
            const min = ag.minutesList.find((m: any) => (m && (m.noteId === noteIdVal)));
            if (min) {
              try { min.noteDescription = this.minAttrList.noteDescription; } catch {}
              break;
            }
          }
        }
      } catch {}
      const legacy = document.createElement('div');
      legacy.id = 'agMinId' + noteIdVal;
      legacy.classList.add('agChildNote', 'minComCls');
      legacy.setAttribute('minId', String(noteIdVal));
      legacy.setAttribute('minid', String(noteIdVal));
      legacy.setAttribute('noteId', String(noteIdVal));
      legacy.setAttribute('agId', String(this.minAttrList.agendaId));
      legacy.setAttribute('agid', String(this.minAttrList.agendaId));
      legacy.setAttribute('parentAgId', String(this.minAttrList.agendaId));
      legacy.setAttribute('entityType', this.minAttrList?.entityType || 'MN');
      legacy.innerHTML = html || '';
      const fakeEvent: any = { target: legacy, currentTarget: legacy, preventDefault: () => {}, stopPropagation: () => {} };
      this.commonMinService.triggerSaveMinutes(legacy, fakeEvent);
    } catch {}
    finally { setTimeout(() => { this.blurSavingGuard = false; }, 250); }
  }
  openLinkToTaskDialog(): void {
    const meetingId = this.meetingResponse?.meetingId;
    const decryptKey = this.minAttrList?.decryptKey;

    if (!meetingId || !this.minAttrList?.noteId) {
      console.error('Meeting ID or Note ID is not defined');
      return;
    }


    this.meetingResponse.agendaList.forEach((agenda: any) => {
      if (agenda.minutesList && agenda.minutesList.length > 0) {
        agenda.minutesList.forEach((minute: any) => {
          if (minute.actionItemOwner && minute.actionItemOwner.length > 0) {
            const ownerNames = minute.actionItemOwner.map((o: any) => o.ownerName);
            this.assignedToMap[minute.taskId] = ownerNames;
          }
        });
      }
    });


    // Step 1: Fetch Task by Meeting
    // Step 1: Fetch Notes first
    this.meetingService.fetchNotes(this.minAttrList.noteId).subscribe({
      next: (notes: any) => {

        const noteInfo = notes.body || [];
        this.noteInfo = noteInfo;
        // Step 2: Fetch Task
        this.meetingService.fetchTaskByMeetingId(meetingId, decryptKey).subscribe({
          next: (taskData: any[]) => {

            this.toLinkingTask = taskData;


            // Step 3: Fetch Agendas
            this.meetingService.fetchAgendaListByMeeting(meetingId).subscribe({
              next: (agendas: any[]) => {

                this.agendasinfoe = agendas || [];

                // Map notes to agendas
                const agendasWithTasks = this.agendasinfoe.map((agenda: { agendaId: any }) => ({
                  ...agenda,
                  notes: this.toLinkingTask.filter((note: { agendaId: any }) => note.agendaId === agenda.agendaId)
                }));

                // 👉 Open dialog after all three are ready
                this.dialog.open(LinkNotetotaskDialogComponent, {
                  data: {
                    meetingRes: this.toLinkingTask,
                    agendas: this.agendasinfoe,
                    agendasWithTasks,
                    noteRes: this.noteInfo,
                    type: "NOTE",
                    assignedTo: this.assignedToMap,
                    meetingTitle: this.meetingResponse.meetingTitle,
                    linkedTaskIds: Array.isArray(this.noteInfo.linkedTaskIds)
                      ? this.noteInfo.linkedTaskIds
                      : []
                  },
                  panelClass: ['animate__animated', 'animate__slideInLeft'],
                  disableClose: false,
                  position: { left: '0%' },
                  maxWidth: '100vw',
                  maxHeight: '100vh',
                  width: '50%',
                  height: '100vh',
                  autoFocus: false
                });
              },
              error: (err: any) => console.error('Error fetching agendas:', err)
            });
          },
          error: (err: any) => console.error('Error fetching task:', err)
        });
      },
      error: (err: any) => console.error('Error fetching notes:', err)
    });
  }

  //     error => {
  //       console.error('Error fetching tasks:', error);
  //     }
  //   );
  // }

  saveContent(event: any) {
    const inputs = document.querySelectorAll('input[name], select[name], textarea[name]');
    const allFields = Array.from(inputs).filter((el: any) => el.name.includes('fld'));
    const formValues: any = {};
    formValues['formId'] = this.proteanFormId;
    if (this.userResponse.length > 0) {
      formValues['pkFormResponse'] = this.userResponse[0].responseId;
    }
    allFields.forEach((el: any) => {
      const fieldId = el.name;
      const fieldValue = (el as HTMLInputElement).value || '';
      formValues[fieldId] = fieldValue;
    });
    const payload = [{ formData: formValues }];
    this.meetingService.saveFormDetails(payload).subscribe((data: any) => {
      var req = {
        responseId: data.body.data.results.pkFormResponse,
        userId: localStorage.getItem('userId'),
        formData: formValues
      }
      var endPath = this.userResponse.length > 0 ? 'updateFormResponse/' : 'saveFormResponse/';
      this.meetingService.saveFormResponse(req, this.minAttrList.noteId, endPath).subscribe((response: any) => {
        this.notifier.show({
          type: 'success',
          message: "Response Updated successfully",
        });
      })

    })

    // })
  }
  getAllProteanForm() {
    var req = {
      page: 1,
      size: 10
    }
    this.meetingService.getAllProteanForm(req).subscribe((res: any) => {
      let attchDialog = this.dialog.open(ProteanFormsComponent, {
        data: { form_response: res.body, noteId: this.minAttrList.noteId, meetingRes: this.meetingResponse },
        panelClass: ['animate__animated', 'animate__slideInLeft'],
        disableClose: true,
        position: {
          left: "0%"
        },
        maxWidth: "100%",
        maxHeight: "100vh",
        width: "80%",
        height: "100vh"
      })
      const mediumDialogSubscription = this.isMedium.subscribe(size => {
        if (size.matches) {
          attchDialog.updateSize('70vw', '100vh');
        }
      })
      const smallSubscription = this.isSmall.subscribe(size => {
        if (size.matches) {
          attchDialog.updateSize('100vw', '100vh');
        }
      })
      const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
        if (size.matches) {
          attchDialog.updateSize('100vw', '100vh');
        }
      });
      attchDialog.afterClosed().subscribe((response: any) => {
        this.rightsList = this.meetingResponse.attendeeList.filter((user: any) => response.editRights.includes(user.fkSecUserAttendee));
        var req = {
          formId: response.data.formObj.formId,
          noteId: this.minAttrList.noteId,
          meetingId: this.minAttrList.meetingId,
          // responseType : response.resType,
          editRights: response.editRights,
          createdBy: localStorage.getItem('userId')
        }
        this.meetingService.saveOrUpdateForm(req).subscribe((data: any) => {
          this.selectedUser = this.rightsList[0];
          this.proteanFormId = response.data.formObj.formId;
          var html = response.data.htmlStr;
          const mappedHtml = this.valueRender(html);
          this.proteanHtml = this.sanitizer.bypassSecurityTrustHtml(mappedHtml);
          this.hideSaveButton = true
          if (this.selectedUser != this.currentUser) {
            this.hideSaveButton = false;
            setTimeout(() => {
              const formData = document.querySelectorAll('input[name], select[name], textarea[name]');
              const allFields = Array.from(formData).filter((el: any) => el.name.includes('fld'));
              allFields.forEach((el: any) => {
                el.setAttribute('readonly', 'true');
              })
            }, 1000);
          }
        })

        // this.proteanHtml = response.data.stringHtml;
        mediumDialogSubscription.unsubscribe()
        smallSubscription.unsubscribe()
        smallDialogSubscription.unsubscribe()
      })
    })

  }

  valueRender(html: string): string {
    const classMapping: { [key: string]: string } = {
      'rows': 'adc-d-flex adc-mb10',
      'cols': 'adc-co adc-p4',
      'row': 'adc-row adc-mb10',
      'col': 'adc-col adc-p4',
      'form-group-left': 'adc-iptgrp-left',
      'form-group': 'adc-iptgrp-top',
      'form-control': 'form-control',
      'btn': 'adc-btn adc-btn-primary',
      'adc-radio-hr': 'adc-rdogrp-hr',
      'adc-radio-vr': 'adc-rdogrp-vr',
      'adc-checkbox-hr': 'adc-chkgrp-hr',
      'adc-checkbox-vr': 'adc-chkgrp-vr',
      'table-warning': 'adc-table-warning',
    };
    for (const [bootstrapClass, customClass] of Object.entries(classMapping)) {
      const regex = new RegExp(`\\b${bootstrapClass}\\b`, 'g');
      html = html.replace(regex, customClass);
    }
    // Dynamic Mapping for class="radX" or class="chkX" (but NOT type="checkbox" or type="radio")
    html = html.replace(/class="([^"]*\brad\d+\b[^"]*)"/g, 'class="adc-rdo"');
    html = html.replace(/class="([^"]*\bchk\d+\b[^"]*)"/g, 'class="adc-chk"');
    const iconMapping: { [key: string]: string } = {
      'zmdi-plus-circle': 'add_circle',
      'zmdi-cloud-upload': 'cloud_upload',
      'zmdi-delete': 'delete',
      'zmdi-edit': 'edit',
      'zmdi-search': 'search',
      'addicon': 'material-icons add_circle',
    };

    for (const [zmdiIcon, materialIcon] of Object.entries(iconMapping)) {
      const regex = new RegExp(`<i class="[^"]*\\bzmdi\\s+${zmdiIcon}[^"]*"></i>`, 'g');

      // if (materialIcon === 'material-icons add_circle') {
      //   html = html.replace(regex, `<i class="material-icons" style="color:#3f51b5 ; cursor: pointer;">add_circle</i>`);
      // } else {
      //   html = html.replace(regex, `<i class="material-icons" style="color:#3f51b5 ; cursor: pointer;">add_circle</i>`);
      // }

      if (materialIcon === 'add_circle') {
        html = html.replace(regex, `<i class="material-icons" style="color:#3f51b5 ; cursor: pointer;">add_circle</i>`);
      } else {
        html = html.replace(regex, `<i class="material-icons" style="cursor: pointer;">${materialIcon}</i>`);
      }
    }
    return html;
  }

  saveFormResponse(isFormComplete: number) {
    const formData = document.querySelectorAll('input[name], select[name], textarea[name]');
    const allFields = Array.from(formData).filter((el: any) => el.name.includes('fld'));
    const formValues: any = {};
    formValues.formId = this.proteanFormId;
    allFields.forEach((el: any) => {
      const fieldId = el.name;
      const fieldValue = (el as HTMLInputElement).value || '';
      formValues[fieldId] = fieldValue;
    });
    const payload = [{ formData: formValues }];
  }

  getFormDetails(req: any) {
    if (req.responseId == undefined || req.responseId == null) {
      this.meetingService.getFormDetails(req).subscribe((res: any) => {
        this.proteanFormId = this.minAttrList.formDetails.formId;
        var html = res.body.data.results.htmlStr;
        const mappedHtml = this.valueRender(html);
        this.proteanHtml = this.sanitizer.bypassSecurityTrustHtml(mappedHtml);
        this.hideSaveButton = true;
        if (this.selectedUser != this.currentUser) {
          this.hideSaveButton = false;
          setTimeout(() => {
            const formData = document.querySelectorAll('input[name], select[name], textarea[name]');
            const allFields = Array.from(formData).filter((el: any) => el.name.includes('fld'));
            allFields.forEach((el: any) => {
              el.setAttribute('readonly', 'true');
            })
          }, 1000);
        }
      })
    }
    else {

      this.meetingService.getFormResponseDetails(req).subscribe((res: any) => {
        this.proteanFormId = this.minAttrList.formDetails.formId;
        var html = res.body.data.results.htmlStr;
        const mappedHtml = this.valueRender(html);
        this.proteanHtml = this.sanitizer.bypassSecurityTrustHtml(mappedHtml);
        this.hideSaveButton = true;
        if (this.selectedUser != this.currentUser) {
          this.hideSaveButton = false;
          setTimeout(() => {
            const formData = document.querySelectorAll('input[name], select[name], textarea[name]');
            const allFields = Array.from(formData).filter((el: any) => el.name.includes('fld'));
            allFields.forEach((el: any) => {
              el.setAttribute('readonly', 'true');
            })
          }, 1000);
        }
      })
    }
  }
  viewUserResponse(event: any) {
    var response: any;
    this.minAttrList.formDetails.formResponse.forEach((data: any) => {
      if (data.userId == event.value) {
        response = data;
      }
    })
    if (response != undefined && response != null) {
      var request = {
        formId: this.minAttrList.formDetails.formId,
        responseId: response.responseId
      }
      this.getFormDetails(request);
      return;
    }
    else {
      var req = {
        formId: this.minAttrList.formDetails.formId,
      }
      this.getFormDetails(req);
      return;
    }
  }



}
